export const getBirthdate = (date) =>
  date?.split('T')[0].split('-').reverse().join('-') || null;
